import Portfolio from '../components/Portfolio';

export default function PortfolioPage() {
  return (
    <main className="flex min-h-screen flex-col bg-white pt-[5.25rem] dark:bg-brand-950 sm:pt-[6.25rem]">
      <Portfolio />
    </main>
  );
}
